import Router from "next/router";
import { NURSEEDU_API_BASE_URL, NURSEEDU_CBT_BASE_URL, NURSEEDU_COMMUNITY_BASE_URL } from "../constant/nurseEduConfig";

/**
 * @description
 * 로그아웃 시에 커뮤니티, 널스에듀, 널스링크 쪽도 로그아웃 시킵니다.
 */
export const logout = (params?: { url: string; asPath: string }) => {

  const uri = "/sso/sign-out";

  const path = params?.asPath || Router.asPath;
  const redirectUri = params?.url || NURSEEDU_CBT_BASE_URL + path;

  const signOutUrl = `${NURSEEDU_API_BASE_URL}${uri}?redirectUri=${redirectUri}`;

  window.location.href = signOutUrl;
};
